<template>
  <div class="main">
    <div id="content">
      <div class="nav">
        <!-- <side-bar :checkOrder="checkOrder" :deriveScreenCheck="deriveScreenCheck"/> -->
        <leftBar
          :checkOrder="checkOrder"
          :deriveScreenCheck="deriveScreenCheck"
        />
      </div>
      <div id="main-container">
        <div class="header">
          <div class="leftInfo">
            <span class="headerName">{{ headerName }}</span>
          </div>
          <div class="rightButton">
            <div class="welcome-text">欢迎您，{{userInfo.realName}}</div>
            <div class="avatar">
              <el-dropdown trigger="hover">
                <el-avatar
                    :src="userInfo.profilePhoto"
                ></el-avatar>
<!--                <div class="item-image-empty" v-else-if="userInfo.realName">
                  <span>{{userInfo.realName.substring(0,1)}}</span>
                </div>
                <div v-else>
                  <el-avatar
                      :src="userInfo.profilePhoto"
                  ></el-avatar>
                </div>-->

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="drop-item" @click="goPersonal">
                      <i class="el-icon-user"></i><span>个人中心</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="drop-item" @click="checkOut">
                      <i class="el-icon-switch-button"></i><span>退出登录</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <router-view
          @deriveCheck="deriveCheck"
          @deriveScreen="deriveScreen"
          @startUpLoad="startUpLoad"
        ></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "../../components/SideBar";
import leftBar from "../../components/leftBar";
export default {
  components: { SideBar, leftBar },
  data() {
    return {
      checkOrder: 0,
      deriveScreenCheck: 0,
      headerName: "",
      uid:localStorage.getItem('_uid'),
      userInfo: {}
    };
  },
  watch:{
    	$route(){
        this.setHeaderName();
	    }
  },
  methods: {
    deriveCheck() {
      this.checkOrder += 1;
    },
    deriveScreen() {
      this.checkOrder += 1;
    },
    startUpLoad() {
      this.deriveScreenCheck += 1;
    },
    setHeaderName() {
      this.headerName = this.$route.meta.title;
    },
    goPersonal(){
      this.$router.push({
        name:'/personal'
      })
    },
    checkOut(){
      this.$http.delete("/api/sso/auth/sign-out").then(res => {
        if (res.status === 200) {
          localStorage.removeItem("_mainId")
          localStorage.removeItem("_uid")
          this.$router.push({
            name: "CheckAuth"
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getUserInfo(){
      let uid = this.uid
      let that = this
      this.$http.get('/portal-api/account/appoint/'+uid+'?setScrmPrivilege=true').then(res=>{
        if(res.data.code==='0'){
          this.userInfo = res.data.data;
          localStorage.setItem('appoint_scrm_all_clue_privilege',res.data.data.scrmAllCluePrivilege);
          // console.log('userInfo',this.userInfo);
        }
      })
    },
  },
  mounted() {
    this.setHeaderName();
    this.getUserInfo()
  },
};
</script>
<style lang="less" scoped>
@import "./../../assets/less/main/main.less";
</style>

